<template>
  <div class="page form_page js_show">
    <div class="weui-form">
      <div class="weui-form__text-area" style="text-align: center;margin-top: -10px;">
        <h2 class="weui-form__title"><i class="weui-icon-success weui-icon_msg1"></i>欢迎{{shopName}}</h2>
        <h2 class="weui-form__title">成功入驻京东平台</h2>
        <p>
          <el-image style="width: 22%;top: 5px;right: 15px;" :src="require('@/assets/jdms.svg')" />
          <el-image style="width: 24%;left: 15px;top: 10px;" :src="require('@/assets/jddj.svg')" />
        </p>
        <div class="weui-form__desc">门店资料已提交，我们将在7个工作日内建店完成。请门店准备以下资料：</div>
      </div>
     <br>
      <div class="weui-form__text-area">
        <h4 style="float: left">● 外网电脑一台</h4><br>
        <div class="weui-form__desc" style="float: left">能访问百度等互联网网址。</div>
      </div><br>
      <div class="weui-form__text-area">
        <h4 style="float: left">● 小票打印机</h4>
        <div class="weui-form__desc" style="float: left">需要在上述系统安装的电脑上安装。</div>
      </div><br>
      <div class="weui-form__text-area" style="text-align: left">
        <h4 style="float: left">● 音响设备</h4>
        <div class="weui-form__desc" style="float: left">确保使用系统的电脑能够声音外放,方便接收订单提醒。</div>
      </div><br>
      <div class="weui-form__text-area">
        <h4 style="float: left">● 准备门店库存资料一份</h4>
        <div class="weui-form__desc" style="float: left">药品编码、条形码、药品名称、库存、售价。</div>
      </div><br>
      <div class="weui-form-preview__ft">
        <a class="weui-form-preview__btn weui-form-preview__btn_primary" href="javascript:" @click="checkComplete">我已完成</a>
        <a class="weui-form-preview__btn weui-form-preview__btn_primary" href="javascript:" @click="moreBuild">继续新建</a>
        <!--<a class="weui-form-preview__btn weui-form-preview__btn_primary" href="javascript:" @click="shareBoss" >转发门店负责人</a>-->
      </div>
      <br>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepShopId: Number,
    required: true
  },
  data () {
    return {
      registeInfo: {
        id: '',
        salesmanPhone: '',
        buildStep: 1
      },
      shopName: ''
    }
  },
  methods: {
    checkComplete () {
      this.$router.push({path: '/jd'})
      /*this.$axios({
        method: 'post',
        url: 'v1/wShopRegister/complete',
        data: {id:this.registeInfo.id,buildStep: 3}
      }).then((response) => {
        if(response.data.code === 200) {

        }else{
          this.$message.error(response.data.msg)
        }
      }).catch((error) => {
        console.log('检查失败')
        this.$message.error(error.data.msg === ''?'检查失败':error.data.msg)
      })*/
    },
    moreBuild(){
      this.$router.push({path: '/jd'})
    },
    getBaseInfo () {
      this.$axios({
        method: 'get',
        url: '/v1/wShopRegister/getShopInfo?id='+this.registeInfo.id,
      }).then((response) => {
        if (response.data.code==200){
          if (response.data.data!=null){
            this.shopName = response.data.data.shopName
          }
        }
      }).catch((error) => {
        console.log('保存失败', '保存失败')
      })
    },
    shareBoss () {
      this.$weChat.shareShopBoss(this)
    },
    handlePrev () {
      this.$emit('change-step', 2)
    }
  },
  mounted() {
    console.log("step2传递的值",this.stepShopId)
    let shopId = this.$route.params.id
    console.log("step3 param id",shopId)
    if (shopId!=null&&shopId!=''&&shopId!=0){
      this.registeInfo.id = shopId
    }else{
      this.registeInfo.id = this.stepShopId
    }

    this.getBaseInfo()
  },
  components: {

  }
}
</script>

<style>
.btnDemo{
  width: 30%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btnInfo{
  width: 45%;
  margin-top: 30px;
}
.item{
  float: left;
  /* margin-left: 23px; */
}
</style>



// WEBPACK FOOTER //
// src/views/jdstoreRegister/jddeptRegister.vue